import axios from "./axios";

export default class service {

    static get() {
        return axios.get('aboutus/list');
    }
   
}